import { render, staticRenderFns } from "./EditControlPoints.vue?vue&type=template&id=4bf3c415&"
import script from "./EditControlPoints.vue?vue&type=script&lang=js&"
export * from "./EditControlPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports